import { cn } from 'lib/utils'
import { EButtonVariant, EButtonStyleVariant } from './enums'

type BuildButtonClassNameOptions = {
  variant?: EButtonVariant
  buttonVariant?: EButtonStyleVariant
  className?: string
}

export const buildButtonClassName = ({
  variant = EButtonVariant.LINK,
  buttonVariant = EButtonStyleVariant.PRIMARY,
  className = '',
}: BuildButtonClassNameOptions) => {
  const isButton = variant === EButtonVariant.BUTTON

  return cn(variant, isButton && `${variant}--${buttonVariant}`, className)
}
